import { useCallback } from "react"
import type { AnchorHTMLAttributes, MouseEvent, Ref } from "react"
import { useHref, useLinkClickHandler, type To } from "react-router-dom"

interface RouterAnchorProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  to: To
  ref?: Ref<HTMLAnchorElement>
}

// Stands in for v7's `Link` as MUI's `component`, since `Link` re-merges the forwarded ref every render.
export default function RouterAnchor({ to, onClick, ref, target, ...anchorProps }: RouterAnchorProps) {
  const href = useHref(to)
  const handleRouterClick = useLinkClickHandler<HTMLAnchorElement>(to, { target })

  const handleClick = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event)
    if (!event.defaultPrevented) {
      handleRouterClick(event)
    }
  }, [onClick, handleRouterClick])

  return <a {...anchorProps} ref={ref} href={href} target={target} onClick={handleClick} />
}
